<template>
  <component :items="sliderItems" :interval="3000" :is="getComponentName()" />
</template>

<script>
import Vue from 'vue'
import { mapGetters, mapActions } from 'vuex'
import Slider from '@/components/Slider.vue'
import CarouselSlider from '@/components/CarouselSlider.vue'

export default Vue.extend({
  name: 'SliderHost',
  components: {
    Slider,
    CarouselSlider
  },
  props: {
    configurations: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
    }
  },
  computed: {
    sliderItems: function () {
      return this.sliders().map((value, index) => {
        return {
          isMain: index === 0,
          src: value.image,
          targetUrl: value.targetUrl
        }
      })
    }
  },
  mounted () {
    if (this.sliderItems.length === 0) {
      this.loadSliders()
    }
  },
  methods: {
    ...mapActions({
      loadSliders: 'productCatalog/loadSliders'
    }),
    ...mapGetters({
      sliders: 'productCatalog/sliders'
    }),
    getComponentName(){
      if (!this.configurations.type){
        return "Slider"
      }
      if(this.configurations.type === 'carousel')
        return "CarouselSlider"
      else
        return "Slider"
    }
  }
})
</script>
